<template>
  <div class="drawer">
    <el-drawer
      size="850px"
      title="出库详情"
      :visible.sync="drawerStatus"
      @close="handleClose"
    >
      <div style="line-height: 44px">
        <el-row
          style="font-size: 12px; color: #333; border-bottom: 1px solid #f2f2f2"
        >
          <el-col :span="8">
            <span class="label">出库单号：</span>
            <span class="value">{{ detail.outOrderNo }}</span>
          </el-col>
          <el-col :span="8">
            <span class="label">出库人：</span>
            <span class="value">{{ detail.outUserName }}</span>
          </el-col>
          <el-col :span="8">
            <span class="label">出库日期：</span>
            <span class="value">
              {{ this.$public.FTime(detail.outDate) }}
            </span>
          </el-col>
        </el-row>
        <el-row
          style="font-size: 12px; color: #333; border-bottom: 1px solid #f2f2f2"
        >
          <el-col :span="8">
            <span class="label">出库类型：</span>
            <span class="value">
              {{ detail.outOrderType && detail.outOrderType.name }}
            </span>
          </el-col>
          <el-col :span="8">
            <span class="label">去往门店：</span>
            <span class="value"> {{ detail.otherShopName }}</span>
          </el-col>
          <el-col :span="8">
            <span class="label">调拨数量：</span>
            <span class="value"> {{ detail.otherShopName }} </span>
          </el-col>
        </el-row>
        <el-row
          style="font-size: 12px; color: #333; border-bottom: 1px solid #f2f2f2"
        >
          <el-col :span="24">
            <span class="label">调拨备注：</span>
            <span class="value">
              {{ detail.remark }}
            </span>
          </el-col>
        </el-row>
      </div>
      <div>
        <el-table
          ref="table"
          :data="tableData"
          row-class-name="row-expand-cove"
          style="width: 100%"
        >
          <el-table-column label="名称">
            <template slot-scope="props">
              {{ props.row.goodsName }}
            </template>
          </el-table-column>
          <el-table-column label="规格">
            <template slot-scope="props">
              <span>{{ props.row.skuValue }}</span>
            </template>
          </el-table-column>
          <el-table-column label="单位" width="60">
            <template slot-scope="props">
              <span>{{ props.row.unit }}</span>
            </template>
          </el-table-column>

          <!-- <el-table-column label="数量" width="60">
            <template slot-scope="props">
              {{ props.row.goodsList.length }}
            </template>
          </el-table-column> -->
          <el-table-column label="操作">
            <template slot-scope="props">
              <el-button
                icon="el-icon-view"
                type="text"
                style="color: #f5882a"
                @click="toogleExpand(props.row)"
                >查看条码</el-button
              >
            </template>
          </el-table-column>
          <el-table-column type="expand" width="30">
            <template slot-scope="props">
              <div>
                <div v-if="!$public.isNull(props.row.goodsList)">
                  <el-tag
                    style="margin: 5px"
                    v-for="item in props.row.goodsList"
                    :key="item.tableKey"
                    :type="getType(item)"
                  >
                    {{ item.customCode }} 总量{{ item.count }}
                  </el-tag>
                </div>
                <div v-else>无条码</div>
              </div>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </el-drawer>
  </div>
</template>

<script>
export default {
  data() {
    return {
      drawerStatus: false,
      detail: {},
      tableData: [],
    };
  },
  props: {
    id: {
      default: () => {
        return {};
      },
    },
  },
  mounted() {
    this.$nextTick(() => {
      this.drawerStatus = true;
      this.getDetail();
    });
  },
  methods: {
    getType(goodscustom) {
      if (goodscustom.isCancel == 1) {
        return "warning";
      }
      if (goodscustom.acceptCount !== 0) {
        return "success";
      }
      if (goodscustom.acceptCount == 0) {
        return "info";
      }
    },
    toogleExpand(row) {
      let $table = this.$refs.table;
      this.tableData.map((item) => {
        if (row.skus != item.skus) {
          $table.toggleRowExpansion(item, false);
        }
      });
      $table.toggleRowExpansion(row);
    },
    handleClose() {
      this.$emit("submit");
    },
    // 提交
    getDetail() {
      let params = {
        orderId: this.id,
      };
      let loading = this.$loading();
      this.$http
        .get(process.env.VUE_APP_Url3 + "api/Warehouse/OutOrder/detail", params)
        .then((res) => {
          loading.close();
          if (res.code == 0) {
            this.detail = res.data;
            console.log(this.detail, "出库详情1111");
            this.formatTableData(this.detail.outOrderItems);
          }
        });
    },
    formatTableData(outOrderItems) {
      let list = [];
      let arr_goodsNameSkus = [];
      for (let i = 0; i < outOrderItems.length; i++) {
        let goodsNameSkus = outOrderItems[i].goodsId + outOrderItems[i].skus;
        let index = arr_goodsNameSkus.indexOf(goodsNameSkus);
        if (index === -1) {
          arr_goodsNameSkus.push(goodsNameSkus);
          outOrderItems[i].goodsList = [
            JSON.parse(JSON.stringify(outOrderItems[i])),
          ];
          list.push(outOrderItems[i]);
        } else {
          list[index].goodsList.push(outOrderItems[i]);
        }
      }
      this.tableData = list;
      console.log(this.tableData, "出库详情");
    },
  },
};
</script>

<style scoped lang="scss">
.drawer {
  width: 0;
  padding: 0 0 0 0;
  ::v-deep.el-drawer {
    .label {
      display: inline-block;
      width: 100px;
      text-align: right;
      flex-shrink: 0;
      line-height: 24px;
    }
    .value {
      line-height: 24px;
    }
  }
}
</style>
